// KnowledgeBase Quasar-style Blockquotes plugin
// Enhances regular Markdown blockquotes (that are NOT callouts) to have
// Quasar-like visuals. Pure DOM/CSS; no Vue components.

import { registerMarkdownPostProcessor } from '../../services/PluginAPI.js'
import './styles/blockquote.css'

function enhanceBlockquote(bq) {
  if (!bq || bq.__kb_qbq_applied) return
  if (bq.classList.contains('kb-callout')) return // handled by callouts plugins
  bq.__kb_qbq_applied = true

  bq.classList.add('kb-qbq')

  // Optional: prepend a quote icon for extra affordance
  const firstChild = bq.firstElementChild
  const iconWrap = document.createElement('span')
  iconWrap.className = 'kb-qbq-icon'
  const i = document.createElement('i')
  i.className = 'material-icons'
  i.textContent = 'format_quote'
  iconWrap.appendChild(i)

  // Insert icon before first paragraph/text
  if (firstChild) bq.insertBefore(iconWrap, firstChild)
  else bq.appendChild(iconWrap)
}

export function registerQuasarBlockquotePlugin() {
  // Run before callouts enhancements but after callouts parsing is fine;
  // we gate on .kb-callout class to avoid double-processing.
  registerMarkdownPostProcessor(
    (root) => {
      const quotes = Array.from(root.querySelectorAll('blockquote'))
      for (const q of quotes) {
        try {
          enhanceBlockquote(q)
        } catch {}
      }
    },
    { sortOrder: 42 }
  )
}

export default { registerQuasarBlockquotePlugin }
